export enum SchoolFeatureId {
    Gamification = 7
}

export interface SchoolFeatures { 
    FlightSchoolId: number;
    FlightSchoolName: string;
    FlightSchoolUrl: string;
    FlightSchoolRegistrationUrl: string;
    FlightSchoolInstructorRegistrationUrl: string;
    RegistrationTypeKey: string;
    AllowInstructorRegistrationRoleSelection: boolean;
    RestrictRegistrationEmailDomains: boolean;
    AllowedRegistrationEmailDomains: string[];
    SubscriptionTierId: number;
    SubscriptionTierName: number;

    IsMarketplaceEnabled: boolean;
    StudentProfitSharingReductionEnabled: boolean;
    DomainAutoJoinSchool: boolean;
    
    Features: number[];
    SubscriptionTierRoleIds: number[];
    SchoolFeatures: number[];
    CourseCount: number;
    PackageCount: number;
    FlightSchoolCreatedDateTime: string;
    FlightSchoolModifiedDateTime: string;
    FlightSchoolThemeId: number;
    HasDefaultPaymentMethod: boolean;
    UniversityBillingModeEnabled: boolean;
    SchoolBillingModeId: number;
    ProcessorConfigId: number;
}
